import { Form, FormGroup, Input, Button } from "reactstrap";
import styles from './Search.module.scss';
import { useState } from "react";
import useNavigateSearch from "../../utils/hooks/useNavigateSearch ";

export default function Search({isHomePage}) {
    const navigateSearch = useNavigateSearch();
    const [search, setSearch] = useState('');

    const handleSearchClick = (e) => {
        e.preventDefault();
        
        navigateSearch(`/product-list/`,{search: search});
        setSearch('');
    }

    const onChangeHandlerSearch = (e) => {
        setSearch(e.target.value);
    }

  return (
    <div className={`${isHomePage ? `position-relative text-center ${styles.lgtSearchBox}` : 'flex-grow-1 me-1 me-sm-4'}`}>
    <Form>
        <FormGroup className={`${isHomePage ? 'd-inline-block mb-2 me-2' : styles.customMargin } ${styles.searchInput}`}>
            <div className="input-group">
                <button 
                    className={`input-group-text border-0 ${isHomePage ? `bg-white ${styles.formControl} ${styles.lgtSearchInput}` : styles.bgSearch}`}
                    onClick={(e) => handleSearchClick(e)}
                    >
                    <i className="bi bi-search"></i>
                </button>
                <Input 
                    type="text" 
                    name="search" 
                    value={search}
                    className={`border-0 form-control ${isHomePage ? `bg-white ${styles.customWidth} ${styles.formControl} ${styles.lgtSearchInput}` : styles.bgSearch}`}
                    placeholder="I'm Looking for ..."
                    onChange={(e) => onChangeHandlerSearch(e)}
                />
            </div>
        </FormGroup>
        {
            isHomePage && 
                <>
                    {/* <FormGroup className="mb-2 me-sm-2 mb-sm-0 d-inline-block">
                        <div className="input-group">
                        <span className="input-group-text bg-white border-0" >
                            <i className="bi bi-geo-alt"></i>
                        </span>
                        <Input type="search" name="location" className={`${styles.formControl} ${styles.lgtSearchInput} bg-white border-0 form-control`} placeholder="Location" />
                        </div>
                    </FormGroup> */}
                    <Button 
                        className={`${styles.lgtIconBtn} d-inline-block border-0`}
                        onClick={(e) => handleSearchClick(e)}
                    >
                        <i className="bi bi-search"></i>
                    </Button>
                </>
        }
    </Form>
    </div>
  )
}
